import $ from "jquery";
import React from "react";
import TokenCollection from '../components/tokenCollection';
import { Inprogress, SomethingWentWrong, InValidCharityType, Success, Revoked, NotStarted, ChooseCharityType } from '../components/getStarted';
import Consent from '../components/consent';
import { includes, has } from 'lodash';
const templateData = $('body').data();

export default class ConfirmationHome extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modalIsOpen: false,
			collectToken: false,
			confirmationStatus: templateData.confirmationStatus,
			errorPage: templateData.confirmationStatus.errorPage || false,
			notValidCharityType: templateData.nonCra || false,
			skipFromCharityType: false,
			charityType: ''
		};
		this.toggleModal = this.toggleModal.bind(this);
		this.viewTokenCollection = this.viewTokenCollection.bind(this);
		this.viewNotStarted = this.viewNotStarted.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.submitCharityType = this.submitCharityType.bind(this);
	}

	toggleModal() {
		this.setState({
			modalIsOpen: true
		});
	}

	viewTokenCollection() {
		this.setState({
			collectToken: true,
		});
	}

	viewNotStarted() {
		this.setState({
			collectToken: false,
		});
	}

	// Charity Type Handler
	handleChange(event) {
		this.setState({
			charityType: event.target.value
		});
	}

	// Submit Charity Type
	submitCharityType() {
		const notEligibleCharityType = ['BR_OTHER', 'MX_OTHER'];
		if (!this.state.charityType) {
			$('.errorMsg').show();
			return false;
		} else if (!includes(notEligibleCharityType, this.state.charityType)) {
			$('.errorMsg').hide();
			this.setState({ skipFromCharityType: true });
		} else if (includes(notEligibleCharityType, this.state.charityType)) {
			this.setState({ notValidCharityType: true });
		}
	}

	render() {
		let confState = this.state.confirmationStatus.state,
			showConsentPage = has(this.state.confirmationStatus, 'showConsentPage'),
			skipFromCharityType = this.state.skipFromCharityType,
			collectToken = this.state.collectToken;

		const cra = { profileLink: templateData.linksDefault.charityupgrade },
			countryCode = templateData.country,
			showCharityType = (confState === 'Not Started') && includes(['BR', 'MX'], countryCode);

		if (this.state.notValidCharityType) {
			return (<InValidCharityType countryCode={countryCode} {...cra} />);
		} else if (this.state.errorPage) {
			return (<SomethingWentWrong />);
		} else if (showCharityType && !skipFromCharityType && !showConsentPage) {
			return (<ChooseCharityType countryCode={countryCode} handleChange={this.handleChange} submitCharityType={this.submitCharityType}/>);
		} else if (showConsentPage) {
			return (<Consent viewNotStarted={this.viewNotStarted} />);
		} else if (!collectToken && !showConsentPage && (confState === 'Not Started')) {
			return (<NotStarted viewTokenCollection={this.viewTokenCollection} toggleModal={this.toggleModal} modalIsOpen={this.state.modalIsOpen} />);
		} else if (confState === 'Confirmed') {
			return (<Success />);
		} else if (confState === 'In Progress') {
			return (<Inprogress />);
		} else if (confState === 'Revoked') {
			return (<Revoked />);
		} else {
			return (<TokenCollection confirmationStatus={this.state.confirmationStatus} />);
		}
	}
};




// WEBPACK FOOTER //
// ./ppcc/confirmation/components/confirmationHome.js